import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";

import { useAppSelector } from "@/stores/hooks";

/**
 * Sign-in for the handoff arriving from the customer host.
 *
 * NOT the plain ProtectedRoute: that navigates to /login with no state, and
 * OidcLoginPage then renders the passive "Sign in to continue" button because
 * it sees no intent. A fresh tab on this origin never has a session, so the
 * handoff hit that every time. Bounce with the intent instead, and carry the
 * path so the issuer returns here rather than to the console.
 */
export const WorkForEntry = ({ children }: { children: ReactNode }) => {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const restoring = useAppSelector((state) => state.auth.restoring);
  const location = useLocation();

  if (restoring) return null;

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          autoStart: true,
          from: { pathname: location.pathname, search: location.search },
        }}
      />
    );
  }

  return <>{children}</>;
};
